import { createContext } from 'react';

export const FetcherContext = createContext();
